var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15_\u9500\u552E\u7EDF\u8BA1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54,52H50.27V25.08a2,2,0,1,0-4,0V52H40.9V36.33a2,2,0,0,0-4,0V52H31.54V31.49a2,2,0,0,0-4,0V52H22.15a1.87,1.87,0,0,0,0-.34V38.52a1.92,1.92,0,0,0-1.93-1.93h-.14a1.92,1.92,0,0,0-1.93,1.93V51.66c0,.12,0,.23,0,.34H12V10a2,2,0,0,0-4,0V52.09A3.92,3.92,0,0,0,11.91,56H54a2,2,0,0,0,0-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,27.53a1.92,1.92,0,0,0,2.73,0l8.26-8.26,10.33,5.45a1.94,1.94,0,0,0,2.26-.35h0l9.29-9.29a1.94,1.94,0,0,0,0-2.73l-.1-.1a1.94,1.94,0,0,0-2.73,0l-8.22,8.22L28.17,15.05a2,2,0,0,0-1.28-.18,1.94,1.94,0,0,0-1.1.54L16.5,24.7a1.94,1.94,0,0,0,0,2.73Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.3e760047.svg";
export { ForwardRef as ReactComponent };